
$('.marquee-text')
          .marquee({
            //If you wish to always animate using jQuery
            allowCss3Support: true
            , //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
            css3easing: 'linear'
            , //requires jQuery easing plugin. Default is 'linear'
            easing: 'linear'
            , //pause time before the next animation turn in milliseconds
            delayBeforeStart: 1000
            , //'left', 'right', 'up' or 'down'
            direction: 'left'
            , //true or false - should the marquee be duplicated to show an effect of continues flow
            duplicated: true
            , //speed in milliseconds of the marquee in milliseconds
            duration: 50000
            , //gap in pixels between the tickers
            gap: 0
            , //on cycle pause the marquee
            pauseOnCycle: false
            , //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
            pauseOnHover: false
            , //the marquee is visible initially positioned next to the border towards it will be moving
            startVisible: true
          });

/* jQuery
================================================== */
$(function() {
  $('.acc__title').click(function(j) {
    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});

$('.feature_slider_collection').slick({
  dots: false,
  infinite: false,
  arrows:true,
  speed: 300,
  centerPadding: '0px',
  slidesToShow: 3, 
    responsive: [
    {
      breakpoint: 798,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1, 
        slidesToScroll: 1
      }
    }
  ]
});

$('.custom_feature_links_slider').slick({
  dots: false,
  infinite: false,
  arrows:true,
  speed: 300,
  centerPadding: '0px',
  slidesToShow: 2, 
    responsive: [ 
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1, 
        slidesToScroll: 1
      }
    }
  ]
});

 $('.testi_monial_slide').slick({

  infinite: true,
 slidesToScroll: 1,
  slidesToShow:2, 
    responsive: [
    {
      breakpoint: 2000,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 1, 
        slidesToScroll: 1
      }
    }
  ]
});


 $('.slider-main_pd').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false, 
  dots: false,
  asNavFor: '.slider-thumb_pdp'
});
$('.slider-thumb_pdp').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-main_pd',
  dots: false,
  arrows: true, 
  infinite: true,
  focusOnSelect: true,
    vertical: true,
  verticalSwiping: true, 
    responsive: [
     
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3, 
        slidesToScroll: 1,
          vertical: false,
      verticalSwiping: false,
      }
    }
  ]
});
     